import React from 'react';
import arrowBlackIcon from '../../../../assets/image/arrow-black-icon.svg';
export default function ActionItem({ action }) {
	return (
		<div className={`${action.isOpenDropdown ? 'report-sub-dropdown-container' : ''}`}>
			<div
				className="d-flex align-items-center cursor-pointer"
				onClick={action.onClick}
			>
				<img
					height={18}
					width={18}
					src={action.icon}
					alt="icon"
				/>

				<div className="d-flex gap-3 px-3 align-items-center">
					<div className="fs-4 fw-bold">{action.label}</div>
					{action.dropdownValue && (
						<div className="fs-4 fw-bold">{`: ${action.dropdownValue}`}</div>
					)}

					{action.showArrow && (
						<span
							style={{
								transition: 'transform 0.2s ease',
							}}
						>
							<img
								src={arrowBlackIcon}
								alt=""
							/>
						</span>
					)}
				</div>
			</div>
			{action.isOpenDropdown && (
				<div className="report-dropdown-options-container">
					{action.options.map((option) => (
						<div
							key={option.key}
							className="p-2 cursor-pointer"
							onClick={() => {
								action.dropdownClick(option.key);
							}}
						>
							{option.label}
						</div>
					))}
				</div>
			)}
		</div>
	);
}
